import React from 'react'
import { connect } from 'react-redux'
import isEqual from 'lodash/isEqual'
import isUndefined from 'lodash/isUndefined'
import { getInstance, sortAscColumn, sortDescColumn, sortNoneColumn, selectRow, deselectRow } from '../store'
import { SelectionWithArrowKeys } from './SelectionWithArrowKeys'

@connect(
  (state, props) => {
    const { sortedColumn, selectedRow } = getInstance(state, props.instanceName) || {}

    return {
      sortedColumn,
      selectedRow,
      isColumnSorted: sortedColumn && sortedColumn.name != null,
      isRowSelected: Boolean(selectedRow),
    }
  },
  {
    sortAscColumn,
    sortDescColumn,
    sortNoneColumn,
    selectRow,
    deselectRow,
  },
)
class Persistor extends React.Component {
  componentDidMount() {
    const { isRowSelected, iRowData, iGetRowNodeId, selectedRow, instanceName } = this.props

    if (isRowSelected) {
      const hasSelectRow = iRowData.reduce(
        (hasSelectedRow, nextRow) =>
          hasSelectedRow ||
          (!isUndefined(iGetRowNodeId)
            ? iGetRowNodeId(nextRow) === iGetRowNodeId(selectedRow)
            : isEqual(nextRow, selectedRow)),
        false,
      )

      if (!hasSelectRow) {
        this.props.deselectRow(instanceName)
      }
    }
  }

  componentDidUpdate(prevProps) {
    const { isRowSelected, selectedRow, iGetRowNodeId } = prevProps
    const { instanceName } = this.props

    if (prevProps.iRowData !== this.props.iRowData) {
      this.props.sortNoneColumn(instanceName)
    }

    if (isRowSelected) {
      if (prevProps.iRowData !== this.props.iRowData || !isEqual(prevProps.iRowData, this.props.iRowData)) {
        const hasSelectRow = this.props.iRowData.reduce(
          (hasSelectedRow, nextRow) =>
            hasSelectedRow ||
            (!isUndefined(iGetRowNodeId)
              ? iGetRowNodeId(nextRow) === iGetRowNodeId(selectedRow)
              : isEqual(nextRow, selectedRow)),

          false,
        )

        if (selectedRow && !hasSelectRow) {
          const prevIndex = prevProps.iRowData.findIndex((i) => isEqual(i, selectedRow))
          let index
          if (!isUndefined(iGetRowNodeId)) {
            index = this.props.iRowData.findIndex(
              (i) => iGetRowNodeId(i) === iGetRowNodeId(selectedRow, this.props.iRowData),
            )
            if (index < 0) {
              index = prevIndex
            }
          }

          this.props.selectRow(instanceName, this.props.iRowData[index] || this.props.iRowData[0])
        } else if (!hasSelectRow) {
          this.props.deselectRow(instanceName)
        }
      }
    }
  }

  getSelectedRowNode = (api) => {
    const { iGetRowNodeId, selectedRow } = this.props

    let selectedRowNode

    if (!isUndefined(iGetRowNodeId)) {
      const rowID = iGetRowNodeId(selectedRow)
      const rowNode = api.getRowNode(rowID)
      selectedRowNode = rowNode
    } else {
      api.forEachNode((node) => {
        const nodeData = node.data

        if (isEqual(nodeData, selectedRow)) {
          selectedRowNode = node
        }
      })
    }

    return selectedRowNode
  }

  persistSortedColumnOnSortChanged = (sortedColumn) => {
    const { instanceName } = this.props
    if (!isUndefined(sortedColumn)) {
      const { colId, sort } = sortedColumn

      if (sort === 'asc') {
        this.props.sortAscColumn(instanceName, colId)
      } else if (sort === 'desc') {
        this.props.sortDescColumn(instanceName, colId)
      }
    } else {
      this.props.sortNoneColumn(instanceName)
    }
  }

  persSelecRowOnGridReady = ({ api }) => {
    if (this.props.isRowSelected) {
      const selectedRowNode = this.getSelectedRowNode(api)

      if (selectedRowNode) {
        selectedRowNode.setSelected(true, true)
      }
    }

    api.addEventListener('rowDataChanged', () => {
      if (this.props.isRowSelected) {
        const selectedRowNode = this.getSelectedRowNode(api)

        if (selectedRowNode) {
          selectedRowNode.setSelected(true, true)
        }
      }
    })
  }

  persSelecRowOnSelectionChanged = ({ api }) => {
    const { instanceName } = this.props

    const selectedRows = api.getSelectedRows()

    if (selectedRows.length > 1) {
      console.error('LKGrid error: there is more than one rows selected')
    }

    const firstSelectedRow = selectedRows[0]

    if (!isUndefined(firstSelectedRow)) {
      this.props.selectRow(instanceName, firstSelectedRow)
    } else {
      this.props.deselectRow(instanceName)
    }
  }

  handleGridReady = ({ api }) => {
    const { isRowSelected, iGetRowNodeId, selectedRow } = this.props

    if (isRowSelected) {
      api.ensureNodeVisible(({ data }) =>
        !isUndefined(iGetRowNodeId) ? iGetRowNodeId(data) === iGetRowNodeId(selectedRow) : isEqual(data, selectedRow),
      )
    }
  }

  render() {
    return (
      <SelectionWithArrowKeys
        {...this.props}
        persistSortedColumnOnSortChanged={this.persistSortedColumnOnSortChanged}
        persSelecRowOnSelectionChanged={this.persSelecRowOnSelectionChanged}
        persSelecRowOnGridReady={this.persSelecRowOnGridReady}
        persistSelRowVisOnGridReady={this.handleGridReady}
      />
    )
  }
}

export default Persistor
